/*
 * Het Dakraam -vergelijk-runtime (dakramen).
 * Eén keer geladen via theme.liquid op collectie-, product- en /pages/vergelijken-pagina's.
 * - Checkbox-state in localStorage (snapshot van specs op aanvink-moment, payload = data-cmp JSON).
 * - Document-level event-delegation: overleeft Dawn's AJAX-herrender van de collectie-grid.
 * - Bar-render + spec-tabel-render (met "toon alleen verschillen" + live prijs/voorraad-refresh).
 * - Prijs staat in de ALTIJD-zichtbare kolomkop (vanaf, live ververst, met "waarom deze prijs"-ⓘ),
 *   zodat de belangrijkste regel niet onder de sticky kop wegscrollt.
 * - Lege rijen vallen weg (graceful): een rij die voor álle getoonde dakramen leeg is wordt niet getoond.
 * - "+ Dakraam toevoegen"-kiezer: voegt vanaf de vergelijkpagina een dakraam toe (catalogus = data-hdr-cmp-catalog).
 */
(function () {
  'use strict';

  // v4 (2026-08-20): payload kreeg het veld `afwerking`. Bewust een NIEUWE key i.p.v. v3 hergebruiken:
  // de opgeslagen items zijn snapshots van het aanvink-moment, dus een v3-item mist `afwerking` en zou
  // naast een vers item een "–" tonen -dat leest als "dit raam heeft geen afwerking", terwijl het
  // alleen een oude snapshot is. Een verlopen selectie (max 3 items) is goedkoper dan een foute rij.
  var KEY = 'hdr_compare_v4'; // v3: payload = data-cmp JSON (beglazing/maten afgeleid, geen kleur/energielabel)
  var MAX = 3;

  // Rij-definitie van de vergelijktabel (prijs staat NIET hier -die zit in de kolomkop).
  var ROWS = [
    { key: 'vendor',    label: 'Merk' },
    { key: 'type',      label: 'Type' },
    { key: 'bediening', label: 'Bediening' },
    { key: 'kozijn',    label: 'Kozijn' },
    // Afwerking staat direct onder Kozijn: beide beschrijven het frame, en de afwerking is pas
    // betekenisvol als je weet of het hout of kunststof is. Waarden komen verbatim uit de
    // variant-optie (VELUX zegt "blank afgelakt", Roto "naturel hout") -bewust niet genormaliseerd,
    // zodat de klant ze herkent van de keuze op de productpagina.
    { key: 'afwerking', label: 'Afwerking', tip: 'De lakkleur van het kozijn: dezelfde constructie, andere afwerking. Bij VELUX kost wit afgelakt hetzelfde als blank; bij Roto is wit hout iets duurder. Kunststof kozijnen zijn altijd wit.' },
    { key: 'beglazing', label: 'Beglazing', tip: 'HR++ of HR+++ (triple). Hoe lager de U-waarde, hoe beter de isolatie.' },
    { key: 'maten',     label: 'Beschikbare maten', tip: 'Het aantal leverbare maten; je exacte maat kies je op de productpagina.' },
    { key: 'garantie',  label: 'Garantie', tip: 'VELUX: tot 10 jaar (gelaagd per onderdeel). Roto: 2 jaar, 5 jaar na gratis registratie.' }
  ];

  // Alleen een array met items die een handle hebben, en nooit meer dan MAX (@dae427): een andere
  // waarde onder KEY (null, {}, [null]) liet syncToggles() op arr.forEach crashen, en dan startte
  // init() de balk, de tabel en de kiezer niet meer.
  function load() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(v)) return [];
      return v.filter(function (it) { return it && typeof it === 'object' && it.handle; }).slice(0, MAX);
    } catch (e) { return []; }
  }
  // Geeft false als de browser niets laat bewaren (opslag geblokkeerd of vol, @dae427); de
  // aanroeper meldt dan geen succes. dispatch() krijgt de stand die er echt staat.
  function save(arr) {
    var ok = true;
    try { localStorage.setItem(KEY, JSON.stringify(arr.slice(0, MAX))); } catch (e) { ok = false; }
    dispatch(ok ? arr : load());
    return ok;
  }
  function dispatch(arr) {
    window.dispatchEvent(new CustomEvent('hdr:compare-change', { detail: { count: arr.length } }));
  }
  // Gemeten grid-hoogte per breakpoint-bucket (mobiel/desktop hebben een andere tabelhoogte). Het
  // inline script in sections/hdr-compare.liquid leest dezelfde sleutel en zet de hoogte als
  // min-height VOOR de eerste paint, zodat noot en footer niet meer ~400 px schuiven zodra de tabel
  // na load verschijnt (desktop CLS 0,3 gemeten 15-09-2026, hub @2c95d0). Sleutelnaam daar letterlijk.
  function hoogteSleutel() { return KEY + '_h_' + (window.innerWidth <= 749 ? 'm' : 'd'); }
  function bewaarGridHoogte(grid) {
    try { var h = grid.offsetHeight; if (h > 0) localStorage.setItem(hoogteSleutel(), String(h)); } catch (e) {}
  }
  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  // Payload = JSON in data-cmp (één bron, gedeeld met de kiezer-catalogus). Fallback op data-handle.
  function itemFromToggle(t) {
    try { return JSON.parse(t.getAttribute('data-cmp') || '{}'); }
    catch (e) { return { handle: t.getAttribute('data-handle') || '' }; }
  }

  /* ---------- Uitleg-tooltip (popover, hover + tap/focus) ----------
     Eén popover-element aan <body> -ontsnapt zo aan de overflow:auto-clip van de
     scroll-container rond de tabel. Werkt op hover (desktop), focus (toetsenbord) én tap (mobiel). */

  var tipEl = null, tipFor = null, tipPinned = false;

  function ensureTipEl() {
    if (!tipEl) {
      tipEl = document.createElement('div');
      tipEl.className = 'hdr-cmp-tip-pop';
      tipEl.setAttribute('role', 'status');
      tipEl.hidden = true;
      document.body.appendChild(tipEl);
    }
    return tipEl;
  }
  function positionTip(target) {
    var r = target.getBoundingClientRect();
    ensureTipEl();
    tipEl.style.left = '0px'; tipEl.style.top = '0px';
    var tr = tipEl.getBoundingClientRect();
    var vw = document.documentElement.clientWidth;
    var x = r.left + r.width / 2 - tr.width / 2;
    x = Math.max(8, Math.min(x, vw - tr.width - 8));
    var y = r.top - tr.height - 8;
    if (y < 8) { y = r.bottom + 8; }
    tipEl.style.left = Math.round(x) + 'px';
    tipEl.style.top = Math.round(y) + 'px';
  }
  function showTip(target) {
    var txt = target.getAttribute('data-tip');
    if (!txt) return;
    ensureTipEl();
    tipEl.textContent = txt;
    tipEl.hidden = false;
    tipFor = target;
    tipPinned = false;
    positionTip(target);
  }
  function hideTip() {
    if (tipEl) tipEl.hidden = true;
    tipFor = null; tipPinned = false;
  }
  function closestTip(e) {
    return (e.target && e.target.closest) ? e.target.closest('.hdr-cmp-tbl__tip') : null;
  }
  function initTooltips() {
    document.addEventListener('mouseover', function (e) { var t = closestTip(e); if (t && !tipPinned) showTip(t); });
    document.addEventListener('mouseout', function (e) { var t = closestTip(e); if (t && !tipPinned && t === tipFor) hideTip(); });
    document.addEventListener('focusin', function (e) { var t = closestTip(e); if (t) showTip(t); });
    document.addEventListener('focusout', function (e) { var t = closestTip(e); if (t && !tipPinned) hideTip(); });
    document.addEventListener('click', function (e) {
      var t = closestTip(e);
      if (t) { e.preventDefault(); if (tipPinned && t === tipFor) { hideTip(); } else { showTip(t); tipPinned = true; } }
      else if (tipFor) { hideTip(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' || e.keyCode === 27) hideTip(); });
    window.addEventListener('scroll', function () { if (!tipFor) return; if (tipPinned) positionTip(tipFor); else hideTip(); }, true);
    window.addEventListener('resize', function () { if (tipFor) positionTip(tipFor); });
  }

  /* ---------- Checkbox-gedrag (document-delegation) ---------- */

  function announce(msg) {
    var live = document.querySelector('[data-hdr-cmp-status]');
    if (live) { live.textContent = ''; setTimeout(function () { live.textContent = msg; }, 30); }
  }

  var limitTimer = null;
  function flashLimit(msg) {
    var bar = document.querySelector('[data-hdr-cmp-bar]');
    if (!bar) return;
    var note = bar.querySelector('[data-hdr-cmp-limit]');
    if (!note) {
      note = document.createElement('div');
      note.className = 'hdr-cmp-bar__limit';
      note.setAttribute('data-hdr-cmp-limit', '');
      note.setAttribute('role', 'status');
      bar.appendChild(note);
    }
    note.textContent = msg;
    note.hidden = false;
    bar.classList.add('hdr-cmp-bar--limit');
    if (limitTimer) clearTimeout(limitTimer);
    limitTimer = setTimeout(function () {
      bar.classList.remove('hdr-cmp-bar--limit');
      note.hidden = true;
    }, 4000);
  }

  function syncToggles() {
    var arr = load();
    var handles = {};
    arr.forEach(function (it) { handles[it.handle] = true; });
    var toggles = document.querySelectorAll('[data-hdr-cmp-toggle]');
    for (var i = 0; i < toggles.length; i++) {
      toggles[i].checked = !!handles[toggles[i].getAttribute('data-handle')];
    }
  }

  // Gedeelde "voeg toe"-helper (checkbox + kiezer). Geeft false als de max bereikt is.
  function addItem(item) {
    if (!item || !item.handle) return false;
    var arr = load();
    for (var i = 0; i < arr.length; i++) { if (arr[i].handle === item.handle) return true; } // al aanwezig
    if (arr.length >= MAX) {
      var msg = 'Je kunt maximaal ' + MAX + ' dakramen vergelijken. Verwijder er eerst één.';
      announce(msg); flashLimit(msg);
      return false;
    }
    arr.unshift(item);
    if (!save(arr)) {
      var fout = 'Toevoegen lukt niet: je browser laat deze site niets bewaren.';
      announce(fout); flashLimit(fout);
      return false;
    }
    announce(escapeHtml(item.title || 'Dakraam') + ' toegevoegd aan vergelijken (' + Math.min(arr.length, MAX) + ' van ' + MAX + ').');
    return true;
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-hdr-cmp-toggle]')) return;
    var handle = t.getAttribute('data-handle');
    var arr = load();
    var idx = -1;
    for (var i = 0; i < arr.length; i++) { if (arr[i].handle === handle) { idx = i; break; } }

    if (t.checked) {
      if (idx < 0) {
        if (!addItem(itemFromToggle(t))) { t.checked = false; }
      }
    } else if (idx >= 0) {
      arr.splice(idx, 1);
      save(arr);
      announce('Verwijderd uit vergelijken.');
    }
  });

  /* ---------- Bar-render ---------- */

  function initBar() {
    var bar = document.querySelector('[data-hdr-cmp-bar]');
    if (!bar) return;
    var itemsEl = bar.querySelector('[data-hdr-cmp-items]');
    var clear = bar.querySelector('[data-hdr-cmp-clear]');
    var go = bar.querySelector('[data-hdr-cmp-go]');

    function liftAboveCookieBanner() {
      var ck = document.querySelector('.hdr-cookie-banner');
      var visible = ck && getComputedStyle(ck).display !== 'none' && ck.getBoundingClientRect().height > 0;
      bar.style.bottom = visible ? (Math.ceil(ck.getBoundingClientRect().height) + 16) + 'px' : '';
    }

    // Tilde vroeger de WhatsApp-floatknop op boven deze balk. Die knop bestaat sinds
    // 24-08-2026 niet meer; de functie zet nu alleen nog een class/CSS-var die niemand
    // leest. Bewust laten staan als haak voor de webchat-knop (GOAL-037).
    function syncWhatsappLift() {
      if (bar.hidden) {
        document.body.classList.remove('has-hdr-cmp');
        document.documentElement.style.removeProperty('--hdr-cmp-bar-top');
        return;
      }
      var topGap = Math.max(0, window.innerHeight - bar.getBoundingClientRect().top);
      document.documentElement.style.setProperty('--hdr-cmp-bar-top', Math.ceil(topGap) + 'px');
      document.body.classList.add('has-hdr-cmp');
    }

    function render() {
      var arr = load();
      if (arr.length === 0) {
        bar.hidden = true; bar.style.bottom = '';
        syncWhatsappLift();
        return;
      }
      bar.hidden = false;
      liftAboveCookieBanner();
      if (go) go.setAttribute('aria-disabled', arr.length < 2 ? 'true' : 'false');
      itemsEl.innerHTML = arr.map(function (it) {
        return '<span class="hdr-cmp-bar__item">' +
          (it.image ? '<img src="' + escapeHtml(it.image) + '" alt="" loading="lazy">' : '') +
          '<span class="hdr-cmp-bar__name" title="' + escapeHtml(it.title || '') + '">' + escapeHtml(it.title || '') + '</span>' +
          '<button type="button" class="hdr-cmp-bar__rm" data-handle="' + escapeHtml(it.handle) + '" aria-label="Verwijder ' + escapeHtml(it.title) + ' uit vergelijken">×</button>' +
          '</span>';
      }).join('');
      syncWhatsappLift();
    }
    itemsEl.addEventListener('click', function (e) {
      var rm = e.target.closest('.hdr-cmp-bar__rm');
      if (!rm) return;
      var h = rm.getAttribute('data-handle');
      save(load().filter(function (it) { return it.handle !== h; }));
      render(); syncToggles();
    });
    if (clear) clear.addEventListener('click', function () { save([]); render(); syncToggles(); });
    window.addEventListener('hdr:compare-change', render);
    document.addEventListener('click', function () { if (!bar.hidden) setTimeout(function () { liftAboveCookieBanner(); syncWhatsappLift(); }, 60); }, true);
    window.addEventListener('resize', function () { if (!bar.hidden) { liftAboveCookieBanner(); syncWhatsappLift(); } });
    render();
  }

  /* ---------- Pagina-render: echte spec-tabel ---------- */

  function moneyFromCents(cents) {
    try { return (cents / 100).toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' }); }
    catch (e) { return null; }
  }

  // Prijs-cel (in de kolomkop): prijs + "waarom deze prijs"-ⓘ samen, zodat de tooltip-ⓘ
  // blijft staan wanneer refreshPrices() de innerHTML overschrijft met de live prijs.
  // Bedrag en ⓘ staan samen in __amt (nowrap): in de smalle mobiele kolom brak de prijs anders in
  // drie regels ("vanaf" / "€ 1.234,00" / "ⓘ") en verschoof de kop (hub @2b3256 punt 2).
  function priceCellHtml(it, liveMoney, availHtml) {
    var money = liveMoney || it.price;
    var why = it.prijsuitleg
      ? ' <span class="hdr-cmp-tbl__tip hdr-cmp-tbl__tip--why" tabindex="0" role="button"' +
        ' aria-label="Waarom deze prijs? ' + escapeHtml(it.prijsuitleg) + '"' +
        ' data-tip="' + escapeHtml(it.prijsuitleg) + '">ⓘ</span>'
      : '';
    var inner = money
      ? 'vanaf <span class="hdr-cmp-tbl__amt">' + escapeHtml(money) + why + '</span>'
      : '<span class="hdr-cmp-tbl__amt"><span class="hdr-cmp-tbl__na">–</span>' + why + '</span>';
    return '<span class="hdr-cmp-tbl__price">' + inner + (availHtml || '') + '</span>';
  }

  function initPage() {
    var grid = document.querySelector('[data-hdr-cmp-page-grid]');
    if (!grid) return;
    var empty = document.querySelector('[data-hdr-cmp-page-empty]');
    var diffWrap = document.querySelector('[data-hdr-cmp-diff-wrap]');
    var diffToggle = document.querySelector('[data-hdr-cmp-diff]');
    var swipe = document.querySelector('[data-hdr-cmp-swipe]');
    var addBtn = document.querySelector('[data-hdr-cmp-addwrap]');
    var onlyDiff = false;

    function cellValue(it, row) {
      var v = it[row.key];
      if (!v) return '<span class="hdr-cmp-tbl__na">–</span>';
      // Beglazing met veel opties: volledig op desktop, eerste 3 + "… meer op de productpagina"
      // op mobiel (CSS-gestuurd via .hdr-cmp-tbl__beg-extra/.beg-more) -zo blijft de mobiele rij compact.
      if (row.key === 'beglazing') {
        var opts = String(v).split(' / ');
        if (opts.length > 3) {
          return escapeHtml(opts.slice(0, 3).join(' / ')) +
            '<span class="hdr-cmp-tbl__beg-extra"> / ' + escapeHtml(opts.slice(3).join(' / ')) + '</span>' +
            '<span class="hdr-cmp-tbl__beg-more"> … <a class="hdr-cmp-tbl__pdp" href="' + escapeHtml(it.url) + '">meer op de productpagina</a></span>';
        }
      }
      return escapeHtml(v);
    }

    function render() {
      var arr = load();
      // Bij 1 dakraam niet: dan staat dezelfde actie als oranje knop in lege plek 2 (hub @2b3256).
      // Gelijk houden aan het inline script in sections/hdr-compare.liquid.
      if (addBtn) addBtn.hidden = arr.length <= 1 || arr.length >= MAX;
      if (arr.length === 0) {
        grid.innerHTML = '';
        grid.style.minHeight = '';
        grid.style.display = '';
        if (empty) empty.hidden = false;
        if (diffWrap) diffWrap.hidden = true;
        if (swipe) swipe.hidden = true;
        return;
      }
      if (empty) empty.hidden = true;
      if (diffWrap) diffWrap.hidden = arr.length < 2;

      var html = '<table class="hdr-cmp-tbl"><thead><tr><th class="hdr-cmp-tbl__corner"></th>';
      arr.forEach(function (it) {
        // __headin is een flex-kolom over de volle kophoogte: prijs en Verwijder zakken naar de
        // onderrand, zodat ze in elke kolom op dezelfde hoogte staan, ook als de ene subtitel
        // een regel langer is (hub @2b3256 punt 3).
        html += '<th scope="col" class="hdr-cmp-tbl__head"><div class="hdr-cmp-tbl__headin">' +
          '<a href="' + escapeHtml(it.url) + '" class="hdr-cmp-tbl__prodlink">' +
          (it.image ? '<span class="hdr-cmp-tbl__img"><img src="' + escapeHtml(it.image) + '" alt=""></span>' : '') +
          '<span class="hdr-cmp-tbl__title">' + escapeHtml(it.title) + '</span></a>' +
          (it.subtitle ? '<span class="hdr-cmp-tbl__subtitle">' + escapeHtml(it.subtitle) + '</span>' : '') +
          '<span class="hdr-cmp-tbl__headprice" data-price-cell="' + escapeHtml(it.handle) + '">' + priceCellHtml(it, null, '') + '</span>' +
          '<button type="button" class="hdr-cmp-tbl__rm" data-handle="' + escapeHtml(it.handle) + '">Verwijder</button>' +
          '</div></th>';
      });
      // Lege plekken tot MAX als kolom tonen (hub @6e6c84, variant B, keuze Ruben 16-09-2026):
      // met 1 dakraam is er niets te vergelijken, en de oude stand (een kolom van 1220 px op desktop)
      // liet dat niet zien. Plek 2 is de volgende stap (oranje knop plus reden), plek 3 een stille
      // ghost. De knoppen dragen data-hdr-cmp-add, dus de bestaande click-handler opent de kiezer.
      // Op mobiel wisselt CSS het lange label (__slot-l) om voor het korte (__slot-s).
      for (var slot = arr.length + 1; slot <= MAX; slot++) {
        html += '<th scope="col" class="hdr-cmp-tbl__head hdr-cmp-tbl__slot" data-slot="' + slot + '">' +
          (slot === 2
            ? '<div class="hdr-cmp-tbl__slotbox is-next">' +
              '<button type="button" class="hdr-cmp-tbl__slotbtn is-primary" data-hdr-cmp-add>' + slotLabel('+ Voeg een 2e dakraam toe', '+ Toevoegen') + '</button>' +
              '<span class="hdr-cmp-tbl__slothint">' + slotLabel('Dan zie je meteen waar ze verschillen.', 'Zie meteen de verschillen.') + '</span>' +
              '</div>'
            : '<div class="hdr-cmp-tbl__slotbox is-later">' +
              '<span class="hdr-cmp-tbl__slotnum">' + slot + 'e dakraam</span>' +
              '<button type="button" class="hdr-cmp-tbl__slotbtn" data-hdr-cmp-add>+ Toevoegen</button>' +
              '</div>') +
          '</th>';
      }
      html += '</tr></thead><tbody>';

      ROWS.forEach(function (row) {
        var rawVals = arr.map(function (it) { return it[row.key] || ''; });
        // Graceful: rij die voor ÁLLE getoonde dakramen leeg is → niet tonen.
        var anyVal = rawVals.some(function (v) { return v && v.length; });
        if (!anyVal) return;
        var differs = rawVals.some(function (v) { return v !== rawVals[0]; });
        var cls = 'hdr-cmp-tbl__row' + (differs ? ' is-diff' : ' is-same');
        var tip = row.tip ? ' <span class="hdr-cmp-tbl__tip" tabindex="0" role="img" aria-label="' + escapeHtml(row.tip) + '" data-tip="' + escapeHtml(row.tip) + '">ⓘ</span>' : '';
        html += '<tr class="' + cls + '" data-diff="' + (differs ? '1' : '0') + '">' +
          '<th scope="row" class="hdr-cmp-tbl__label">' + escapeHtml(row.label) + tip + '</th>';
        arr.forEach(function (it) {
          html += '<td class="hdr-cmp-tbl__cell' + (differs ? ' is-diff' : '') + '">' + cellValue(it, row) + '</td>';
        });
        for (var s = arr.length + 1; s <= MAX; s++) {
          html += '<td class="hdr-cmp-tbl__cell hdr-cmp-tbl__slotcell" data-slot="' + s + '"></td>';
        }
        html += '</tr>';
      });
      html += '</tbody></table>';
      grid.innerHTML = html;
      // Reservering van het inline script opheffen nu de echte tabel er staat, en de hoogte bewaren
      // voor het volgende bezoek (nog eens na 2 s, als prijzen en beelden zijn geladen).
      grid.style.minHeight = '';
      grid.style.display = '';
      bewaarGridHoogte(grid);
      setTimeout(function () { bewaarGridHoogte(grid); }, 2000);
      applyDiffFilter();
      refreshPrices(arr);
      // Veeg-hint alleen tonen als de tabel écht breder is dan het scrollvenster (anders misleidend:
      // op mobiel passen 2 producten nu samen in beeld, dan is er niets te vegen). Sinds de lege
      // plekken als kolom staan (16-09-2026) scrolt de tabel ook bij 1 dakraam, dus het aantal
      // dakramen telt niet meer mee; alleen de gemeten breedte.
      if (swipe) swipe.hidden = grid.scrollWidth <= grid.clientWidth + 2;
    }

    // Lange en korte tekst voor een lege plek; CSS toont er per viewport precies een.
    function slotLabel(lang, kort) {
      return '<span class="hdr-cmp-tbl__slot-l">' + lang + '</span><span class="hdr-cmp-tbl__slot-s">' + kort + '</span>';
    }

    function applyDiffFilter() {
      var rows = grid.querySelectorAll('.hdr-cmp-tbl__row');
      for (var i = 0; i < rows.length; i++) {
        rows[i].hidden = onlyDiff && rows[i].getAttribute('data-diff') === '0';
      }
    }

    // Live prijs/voorraad uit /products/{handle}.js (metafields zitten daar niet) → kop-prijscel updaten.
    function refreshPrices(arr) {
      arr.forEach(function (it) {
        if (!it.handle) return;
        fetch('/products/' + encodeURIComponent(it.handle) + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { if (!r.ok) throw new Error('404'); return r.json(); })
          .then(function (p) {
            var cell = grid.querySelector('[data-price-cell="' + cssEscape(it.handle) + '"]');
            if (!cell) return;
            var money = moneyFromCents(p.price);
            var avail = p.available === false ? ' <span class="hdr-cmp-tbl__oos">Tijdelijk uitverkocht</span>' : '';
            if (money) cell.innerHTML = priceCellHtml(it, money, avail);
          })
          .catch(function () {
            var cell = grid.querySelector('[data-price-cell="' + cssEscape(it.handle) + '"]');
            if (cell) {
              var price = cell.querySelector('.hdr-cmp-tbl__price');
              if (price) price.innerHTML += ' <span class="hdr-cmp-tbl__note">(controleer op productpagina)</span>';
            }
          });
      });
    }

    grid.addEventListener('click', function (e) {
      var rm = e.target.closest('.hdr-cmp-tbl__rm');
      if (!rm) return;
      var h = rm.getAttribute('data-handle');
      save(load().filter(function (it) { return it.handle !== h; }));
      render(); syncToggles();
    });
    if (diffToggle) diffToggle.addEventListener('change', function () { onlyDiff = diffToggle.checked; applyDiffFilter(); });

    window.addEventListener('hdr:compare-change', render);
    render();
    initPicker();
  }

  /* ---------- Kiezer: "+ Dakraam toevoegen" op de vergelijkpagina ---------- */

  function initPicker() {
    var picker = document.querySelector('[data-hdr-cmp-picker]');
    var catalogEl = document.querySelector('[data-hdr-cmp-catalog]');
    if (!picker || !catalogEl) return;
    var CATALOG = [];
    try { CATALOG = JSON.parse(catalogEl.textContent) || []; } catch (e) { CATALOG = []; }
    var listEl = picker.querySelector('[data-hdr-cmp-picker-list]');
    var searchEl = picker.querySelector('[data-hdr-cmp-picker-search]');
    var lastFocus = null;

    function inCompare(handle) {
      return load().some(function (it) { return it.handle === handle; });
    }
    function renderList() {
      var q = (searchEl && searchEl.value || '').trim().toLowerCase();
      var atMax = load().length >= MAX;
      var items = CATALOG.filter(function (c) {
        if (!q) return true;
        return (c.title + ' ' + c.vendor + ' ' + c.type).toLowerCase().indexOf(q) !== -1;
      });
      if (!items.length) {
        listEl.innerHTML = '<li class="hdr-cmp-picker__none">Geen dakraam gevonden.</li>';
        return;
      }
      listEl.innerHTML = items.map(function (c) {
        var added = inCompare(c.handle);
        var disabled = added || atMax;
        return '<li><button type="button" class="hdr-cmp-picker__item" data-handle="' + escapeHtml(c.handle) + '"' +
          (disabled ? ' disabled' : '') + '>' +
          (c.image ? '<img src="' + escapeHtml(c.image) + '" alt="" loading="lazy">' : '<span class="hdr-cmp-picker__noimg"></span>') +
          '<span class="hdr-cmp-picker__txt"><span class="hdr-cmp-picker__name">' + escapeHtml(c.title) + '</span>' +
          '<span class="hdr-cmp-picker__meta">' + escapeHtml(c.vendor) + (c.price ? ' · vanaf ' + escapeHtml(c.price) : '') + '</span></span>' +
          '<span class="hdr-cmp-picker__act">' + (added ? '✓ toegevoegd' : (atMax ? 'max 3' : '+ toevoegen')) + '</span>' +
          '</button></li>';
      }).join('');
    }
    function open() {
      lastFocus = document.activeElement;
      picker.hidden = false;
      document.body.style.overflow = 'hidden';
      if (searchEl) { searchEl.value = ''; }
      renderList();
      if (searchEl) setTimeout(function () { searchEl.focus(); }, 30);
    }
    function close() {
      picker.hidden = true;
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-hdr-cmp-add]')) { e.preventDefault(); open(); return; }
      if (e.target.closest('[data-hdr-cmp-picker-close]')) { close(); return; }
      var item = e.target.closest('.hdr-cmp-picker__item');
      if (item && !item.disabled && !picker.hidden) {
        var h = item.getAttribute('data-handle');
        var c = CATALOG.filter(function (x) { return x.handle === h; })[0];
        if (c && addItem(c)) { syncToggles(); renderList(); }
      }
    });
    if (searchEl) searchEl.addEventListener('input', renderList);
    document.addEventListener('keydown', function (e) { if ((e.key === 'Escape' || e.keyCode === 27) && !picker.hidden) close(); });
    window.addEventListener('hdr:compare-change', function () { if (!picker.hidden) renderList(); });
  }

  // Minimal CSS.escape-fallback (handles bestaan uit [a-z0-9-]).
  function cssEscape(s) { return String(s).replace(/[^a-zA-Z0-9_-]/g, '\\$&'); }

  /* ---------- Init + Dawn-AJAX-resync ---------- */

  function init() {
    initTooltips();
    syncToggles();
    initBar();
    initPage();
    var gridContainer = document.getElementById('ProductGridContainer');
    if (gridContainer && 'MutationObserver' in window) {
      var t;
      new MutationObserver(function () {
        clearTimeout(t); t = setTimeout(syncToggles, 80);
      }).observe(gridContainer, { childList: true, subtree: true });
    }
    window.addEventListener('hdr:compare-change', syncToggles);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
